import {catchhandler, send, get} from "@geekjob/lib/http"

var emptyCV = {
	id: null,
	positionCurrent: null,
	positionDesired: null,
	public: true
}

function rus2lat(str) {
	var ru = {
			'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd',
			'е': 'e', 'ё': 'e', 'ж': 'j', 'з': 'z', 'и': 'i',
			'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
			'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u',
			'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh',
			'щ': 'shch', 'ы': 'y', 'э': 'e', 'ю': 'u', 'я': 'ya'
		},
		ns = []

	str = str.replace(/[ъь]+/g, '').replace(/й/g, 'i')
	for (let i = 0; i < str.length; ++i) {
		ns.push(
			ru[str[i]]
			|| ru[str[i].toLowerCase()] == void 0 && str[i]
			|| ru[str[i].toLowerCase()].replace(/^(.)/, match => match.toUpperCase())
		)
	}
	return ns.join('')
}

export default {
	name: 'RespondForm',
	data() {
		return {
			domain: window.mainDomain,
			company: window.Company,
			anonim: false,
			currentUri: location.href,
			vacancy: window.Vacancy,
			vacancyTitle: window.Vacancy.position,
			//email: '',
			cvid: null,
			text: '',
			loading: false,
			cvList: [],
			user: {},
			selectedIndex: 0,
			responded: false,
			show: false,
			oldresponds: 0
		}
	},
	created() {
		get
			.call(this, '/json/mycvlist?vid=' + window.Vacancy.id, true)
			.then(res => {
				if (res.error) return

				this.show = true
				if (res.responded) {
					this.responded = true
					$('.respondbtn')
						.addClass('grey')
						.click(function (e) {
							e.preventDefault()
						})
						.text('уже откликнулись')

					return
				}

				this.cvList = res.data
				this.user = res.user
				this.oldresponds = res.oldresponds || 0

				let cv = this.cvList.length
					? this.cvList[0]
					: emptyCV


				this.messageText(cv)
				if (!cv.public) this.anonim = true
			})
			.catch(catchhandler.bind(this))
	},
	methods: {
		getItemByIndex(idx) {
			if ('x' == idx) return emptyCV
			return this.cvList[idx]
		},
		setMessage(e) {
			var cv = this.getItemByIndex(e.target.value)
			this.selectedIndex = e.target.value || 0
			this.messageText(cv)
			this.anonim = !cv.public
		},
		messageText(cv) {
			var cvtext
			if (cv.id) {
				if ('en' == this.vacancy.lang) {
					cvtext = (cv.public
							? 'You can see my resume here '
							: 'I am looking for work anonymously. You are added to my whitelist, so you can see my resume at the link '
					) + 'https://geekjob.ru/geek/' + cv.id
				} else {
					cvtext = (cv.public
							? 'Вы можете посмотреть мое резюме по ссылке '
							: 'Я ищу работу анонимно. Вы добавлены в мой "белый" список, поэтому вы можете увидеть мое резюме по ссылке '
					) + 'https://geekjob.ru/geek/' + cv.id
				}
			} else {
				cvtext = 'en' == this.vacancy.lang
					? 'I have not uploaded a resume file, but you can write me on e-mail ' + this.user.email
					: 'Я не загрузил резюме, но вы можете написать мне на почту ' + this.user.email
			}

			this.text = ({
				ru: `Здравствуйте!
Меня заинтересовала ваша вакансия "${this.vacancyTitle}" (${this.currentUri.replace(/(#.*)$/, '')})

${cvtext}

Заранее благодарю за ответ.
`,
				en: `Hello! I was interested in your vacancy
"${this.vacancyTitle}" (${this.currentUri.replace(/(#.*)$/, '')})

${cvtext}

If you are interested in me, answer, please. Have a nice day!
`,
			})[this.vacancy.lang || 'ru']
		},
		sendForm() {
			// POST form data
			this.cvid = (this.getItemByIndex(this.selectedIndex) || {}).id || null
			let hashhlink = this.detectExternalLinks()
			this.send('/json/respond/vacancy')
			if (hashhlink) {
				// create CV from link
			}
		},
		send(uri) {
			// console.log('Send...')
			// return;

			send
				.call(this, uri, {
					body: JSON.stringify({
						'text': this.text,
						'vic': window.Vacancy.ic, // vacancy _creator
						'vid': window.Vacancy.id, // vacancy _id
						'vci': window.Vacancy.ci, // vacancy _company_id
						'cid': this.cvid, // CV ID
					})
				})
				.then(res => {
					if (res.error) {
						let message = 'Что-то пошло не так, серверная ошибка.'
						if (res.message) message = res.message
						new Swal({type: 'error', text: message})
						return
					}
					this.responded = true
				})
				.catch(catchhandler.bind(this))
		},
		detectExternalLinks() {
			// Detect HH.ru links
			var link = this.text.match(/https?:\/\/(.*)?hh\.ru\/[\/a-z\d_-]+/i)
			if (!link) return 0;
			link = link[0]

			if (this.cvid) {
				// Если и так уже указано резюме, то просто меняем ссылку
				this.text = this.text.replace(link, `https://${this.domain}/geek/${this.cvid}`)
				return 0
			}

			if (this.cvList.length) {
				// Если CV не выбрано, но оно есть, то
				this.cvid = this.cvList[0]
				this.text = this.text.replace(link, `https://${this.domain}/geek/${this.cvid}`)
				return 0
			}
/*
			else {
				// иначе если CV вообще не создано,
				 создаем и рассказываем что лучше использовать это резюме
				Swal
					.fire({
						showCloseButton: true,
						showCancelButton: true,
						html: 'Вы указали в тексте ссылку на резюме на внешнем работном ресурсе. ' +
							'Будет создано резюме автоматически, данные будут взяты по ссылке <br>' + link +
							'.<br> Мы рекомендуем <a href="https://my.' + this.domain + '/cv/edit?onlyfile=1" target="_blank">создать резюме</a> у нас (вы можете создать его в анонимном формате при желании) ' +
							'и работодатель получит ссылку на ваш профиль автоматически. ' +
							'Вы можете сохранить ваше резюме на hh.ru в формате PDF и <a href="https://my.' + this.domain + '/cv/edit?onlyfile=1" target="_blank">загрузить к нам</a>'
					})
					.then(res => {
						if (!res.value) return;
						notie.alert({
							type: 'info',
							text: 'Создаем резюме...',
							time: 30
						})

						// send hh url to parser service
						send
							.call(this, '/json/import/hh', {
								body: JSON.stringify({
									url: link
								})
							})
							.then(res => {
								console.log(res)
								if (res.error) return;
								// get created CV ID
								this.cvid = res.cvid
								this.send('/json/respond/vacancy')
							})
							.catch(catchhandler.bind(this))
					})
			}
//*/
		}
	},
	computed: {
		validForm() {
			return this.text.length > 30
		},
		emptyList() {
			return this.cvList.length < 1
		}
	}
}
